import * as Stimulus from "@hotwired/stimulus"

export class ClipboardController extends Stimulus.Controller {
    static values = {
        copyText: String
    }

    static targets = ["copyAction", "copySuccess", "copyButton"];

    connect() {
    }

    copy() {
        this.copyButtonTarget.disabled = true;
        navigator.clipboard.writeText(this.copyTextValue)
            .then(() => {
                this.copyButtonTarget.innerHTML = this.copySuccessTarget.innerHTML;
                setTimeout(() => {
                    this.copyButtonTarget.innerHTML = this.copyActionTarget.innerHTML;
                    this.copyButtonTarget.disabled = false;
                }, 2000);
            })
            .catch(err => {
                console.error('clipboard#copy', err)
            })
    }
}

